import React, { useState, useEffect } from "react";

const BackToTopButton = () => {
  const [isVisible, setIsVisible] = useState(false);

  const toggleVisibility = () => {
    if (window.pageYOffset > 300) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  useEffect(() => {
    window.addEventListener("scroll", toggleVisibility);
    return () => {
      window.removeEventListener("scroll", toggleVisibility);
    };
  }, []);

  return (
    <button
      className={`back-to-top btn btn-primary rounded-circle ${
        isVisible ? "visible" : ""
      }`}
      onClick={scrollToTop}
      style={{ position: "fixed", bottom: "20px", right: "20px" }}
    >
      ⬆︎
    </button>
  );
};

export default BackToTopButton;
